module.exports = __webpack_public_path__ + "assets/webgl/lens_reflection.jpg.dbf6bb42.webp";